import { useMemo } from 'react';
import type { ODataGridColumn } from '@inuxe/prime-odata-grid';
import type { IAppointment } from '../../../models/appointment/AppointmentModel';
import AppointmentsActionCell from './parts/AppointmentsActionCell';

export function useAppointmentsColumns(): ODataGridColumn<IAppointment>[] {
  return useMemo<ODataGridColumn<IAppointment>[]>(
    () => [
      {
        id: 'actions',
        header: 'İşlemler',
        sortable: false,
        filter: false,
        width: 140,
        className: 'grid-action-column',
        actionSticky: 'left',
        body: row => <AppointmentsActionCell row={row} />,
      },
      {
        field: 'personName',
        header: 'Kişi Adı',
        minWidth: 150,
        sortable: true,
        filter: true,
      },
      {
        field: 'requestNumber',
        header: 'Etiket Numarası',
        minWidth: 150,
        sortable: true,
        filter: true,
      },
      {
        field: 'hospitalName',
        header: 'Hastane',
        minWidth: 150,
        sortable: true,
        filter: true,
      },
      {
        field: 'appointmentDate',
        header: 'Randevu Tarihi',
        dataType: 'date',
        minWidth: 150,
        sortable: true,
        filter: true,
        body: row =>
          row.appointmentDate
            ? new Date(row.appointmentDate).toLocaleDateString('tr-TR')
            : '',
      },
      {
        field: 'appointmentStartTime',
        header: 'Başlangıç',
        minWidth: 90,
        sortable: true,
        filter: true,
      },
      {
        field: 'appointmentEndTime',
        header: 'Bitiş',
        minWidth: 90,
        sortable: true,
        filter: true,
      },
      {
        field: 'userName',
        header: 'Kullanıcı',
        minWidth: 120,
        sortable: true,
        filter: true,
        body: row => row.userName || row.userId || '-',
      },
      {
        field: 'deviceList',
        header: 'Cihaz Listesi',
        minWidth: 150,
        sortable: true,
        filter: true,
      },
    ],
    []
  );
}
